export enum MexusViewMode {
  LIVE = 'LIVE',

  PREVIEW = 'PREVIEW',
}
